import * as R from 'ramda';

function MultiSelect({ options, value, display, onChange }) {
    return (
        <select
            style={{ minWidth: '500px', minHeight: '300px' }}
            multiple
            onChange={(e) => {
                let options = e.target.options;
                let selectedOptions = [];
                R.forEach(option => {
                    if (option.selected) {
                        selectedOptions.push(option.value);
                    }
                })(options);
                onChange(selectedOptions);
            }}
        >
            {
                options.map(option => (
                    <option key={value(option)} value={value(option)}> { display(option) } </option> 
                ))
            }
        </select>
    )
}

export default MultiSelect;